import axios from 'axios'
import { apiUrl } from './../config'
import { clearToken, getToken, setToken } from './auth-storage'

let refreshPromise = null

function resolveAccessToken(data) {
  if (!data) {
    return null
  }
  return data.accessToken || data.token || null
}

function buildAuthApiUrl(pathname) {
  return `${apiUrl}/admin/${pathname}`
}

export async function refreshAccessToken() {
  if (!refreshPromise) {
    refreshPromise = axios
      .post(buildAuthApiUrl('account/refresh'), {}, { withCredentials: true })
      .then(({ data }) => {
        const accessToken = resolveAccessToken(data)
        if (!accessToken) {
          throw new Error('No access token in refresh response')
        }
        setToken(accessToken)
        return accessToken
      })
      .catch((error) => {
        clearToken()
        throw error
      })
      .then((token) => {
        refreshPromise = null
        return token
      })
      .catch((error) => {
        refreshPromise = null
        throw error
      })
  }

  return refreshPromise
}

export async function logoutRemote() {
  try {
    await axios.post(buildAuthApiUrl('account/logout'), {}, { withCredentials: true })
  } catch (error) {
    // local logout should still complete even if remote call fails
  }
  clearToken()
}

export function getAuthorizationHeader() {
  const token = getToken()
  if (!token) {
    return null
  }
  return `JWT ${token}`
}

export function getAccessTokenFromResponse(data) {
  return resolveAccessToken(data)
}



// WEBPACK FOOTER //
// ./src/helpers/auth-client.js